import React, { ReactNode } from 'react';
import './AnalyticsStyleEmptyState.css';

export interface AnalyticsStyleEmptyHint {
  icon: string;
  text: string;
}

export interface AnalyticsStyleEmptyStateProps {
  title: string;
  description: string;
  icon: ReactNode;
  primaryLabel?: string;
  onPrimary: () => void;
  secondaryLabel?: string;
  onSecondary?: () => void;
  hints?: AnalyticsStyleEmptyHint[];
}

const AnalyticsStyleEmptyState: React.FC<AnalyticsStyleEmptyStateProps> = ({
  title,
  description,
  icon,
  primaryLabel = 'Start an Interview',
  onPrimary,
  secondaryLabel = 'Go to Dashboard',
  onSecondary,
  hints = [],
}) => (
  <div className="analytics-empty-state">
    <div className="empty-state-icon">{icon}</div>
    <h2 className="empty-state-title">{title}</h2>
    <p className="empty-state-description">{description}</p>
    <div className="empty-state-actions">
      <button type="button" className="empty-state-cta" onClick={onPrimary}>
        {primaryLabel}
      </button>
      {onSecondary && (
        <button type="button" className="empty-state-secondary" onClick={onSecondary}>
          {secondaryLabel}
        </button>
      )}
    </div>
    {hints.length > 0 && (
      <div className="empty-state-hints">
        {hints.map((h, i) => (
          <div key={i} className="empty-state-hint">
            <span className="hint-icon">{h.icon}</span>
            <span>{h.text}</span>
          </div>
        ))}
      </div>
    )}
  </div>
);

export default AnalyticsStyleEmptyState;
